<template>
  <div class="mobileCurriculum">
    <van-nav-bar
      :title="viewTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div
      class="video"
      :class="{ 'full-screen': fullScreen }"
      :style="{
        width: fullScreen ? fullScreenWidth + 'px' : '100%',
        height: fullScreen ? fullScreenHeight + 'px' : 'auto',
        top: fullScreen
          ? fullScreenWidth / 2 - fullScreenHeight / 2 - 25 + 'px'
          : 0,
        left: fullScreen ? -fullScreenWidth / 4 + 'px' : 0,
      }"
      style="text-align: center"
    >
      <div
        class="mobile-video-frame"
        :style="{
          width: fullScreen
            ? isHorizontal
              ? isiOS
                ? '70%'
                : '65%'
              : '90%'
            : '100%',
          padding: fullScreen ? '2%' : 0,
          boxSizing: 'border-box',
        }"
      >
        <div class="mobile-video-aspect">
          <video-player
            v-if="playerOptions.sources.length"
            :key="videoPlayerRemountKey"
            class="mobile-video-player video-player vjs-custom-skin"
            :class="{ aliving: videoType == 'liveing' }"
            style="display: block"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @playing="onPlayerPlaying($event)"
            @pause="onPlayerPause($event)"
            @timeupdate="timeupdate"
            @seeking="onPlayerSeeking"
            @seeked="onPlayerSeeked"
            @ended="onPlayerEnded"
          >
          </video-player>
          <div
            v-else
            class="mobile-video-placeholder"
            role="status"
            aria-live="polite"
          >
            <div class="mobile-video-placeholder__glow" aria-hidden="true"></div>
            <div class="mobile-video-placeholder__icon-wrap">
              <van-icon name="play-circle-o" class="mobile-video-placeholder__icon" />
            </div>
            <p class="mobile-video-placeholder__title">暂无播放内容</p>
            <p class="mobile-video-placeholder__hint">
              请切换到「课程目录」并选择课件开始学习
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="video-list">
      <van-tabs v-model:active="activeTab">
        <van-tab title="简介">
          <div class="mobile-tab-intro">{{ description }}</div>
        </van-tab>
        <van-tab title="课程目录">
          <div class="mobile-tab-course">
          <!-- 状态 B：计划已锁定 - 分层视图 -->
          <template v-if="needStudyPlan && planLocked">
            <div class="mobile-course-locked-scroll">
            <div v-if="planSections.length" class="mobile-plan-block">
              <p style="color: #677897; font-size: 16px; font-weight: bold">我的学习计划 <span style="font-size: 12px; font-weight: normal; color: #909399;">(包含必修及已选修)</span></p>
              <div class="video-item" v-for="i in planSections" :key="'plan-'+i.id">
                <div class="video-title">{{ i.title }}</div>
                <div class="video-item-list" v-for="s in i.coursewares" :key="s.id"
                  :class="{ active: s.id == activeVideo && s.sectionId == actvieVideoSections }"
                  @click="viewViedo(s)">
                  <div class="video-item-list__top">
                  <div class="main-title">
                    <el-icon class="main-title-icon" style="margin-right: 5px"><VideoCameraFilled /></el-icon>
                    <van-tag
                      :type="isCoursewareRequired(s) ? 'danger' : 'success'"
                      :plain="!isCoursewareRequired(s)"
                      size="medium"
                      class="main-title-tag"
                    >
                      <span style="display: inline-flex; align-items: center; gap: 2px">
                        <van-icon v-if="isCoursewareRequired(s)" name="lock" style="font-size: 14px" />
                        <span>{{ isCoursewareRequired(s) ? '必修' : '选修' }}</span>
                      </span>
                    </van-tag>
                    <span class="main-title-text" :title="s.title">{{ s.title }}</span>
                  </div>
                  <div class="video-item-list__meta">
                  <span class="timer">{{ formatterData(s.vedio && s.vedio.timeLength) }}</span>
                  <span v-if="s.classHour" class="class-hour-tag"><span class="class-hour-num">{{ s.classHour }}</span> 课时</span>
                  </div>
                  </div>
                  <p class="video-item-list__progress">
                    <span class="video-item-list__progress-label">学习进度：</span>{{ coursewareProgressText(s) }}<span :class="isCoursewareDone(s) ? 'status-done' : 'status-undone'">{{ isCoursewareDone(s) ? "已完成" : "未完成" }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="extraSections.length" class="mobile-plan-block mobile-plan-block--extra">
              <p style="color: #677897; font-size: 16px; font-weight: bold; opacity: 0.6">未选修课件 <span style="font-size: 12px; font-weight: normal; color: #909399;">(知识拓展)</span></p>
              <div class="video-item" v-for="i in extraSections" :key="'extra-'+i.id">
                <div class="video-title" style="opacity: 0.45">{{ i.title }}</div>
                <div class="video-item-list" v-for="s in i.coursewares" :key="s.id"
                  style="opacity: 0.45"
                  :class="{ active: s.id == activeVideo && s.sectionId == actvieVideoSections }"
                  @click="viewViedo(s)">
                  <div class="video-item-list__top">
                  <div class="main-title">
                    <el-icon class="main-title-icon" style="margin-right: 5px"><VideoCameraFilled /></el-icon>
                    <van-tag type="success" plain size="medium" class="main-title-tag">选修</van-tag>
                    <span class="main-title-text" :title="s.title">{{ s.title }}</span>
                  </div>
                  <div class="video-item-list__meta">
                  <span class="timer">{{ formatterData(s.vedio && s.vedio.timeLength) }}</span>
                  <span v-if="s.classHour" class="class-hour-tag"><span class="class-hour-num">{{ s.classHour }}</span> 课时</span>
                  </div>
                  </div>
                  <p class="video-item-list__progress">
                    <span class="video-item-list__progress-label">学习进度：</span>{{ coursewareProgressText(s) }}<span :class="isCoursewareDone(s) ? 'status-done' : 'status-undone'">{{ isCoursewareDone(s) ? "已完成" : "未完成" }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div style="text-align: center; padding: 12px 0">
              <van-button type="warning" plain size="small" @click="modifyPlan">修改学习计划</van-button>
            </div>
            </div>
          </template>

          <!-- 状态 A：选课模式下列表单独滚动，底部条固定在 Tab 可视区域底部 -->
          <template v-if="!(needStudyPlan && planLocked)">
            <div
              v-if="videos.length"
              class="mobile-catalog-flat-root"
              :class="{ 'mobile-catalog-flat-root--with-footer': needStudyPlan && !planLocked }"
            >
              <div class="mobile-catalog-flat-scroll">
                <p class="mobile-catalog-section-title">
                  {{ needStudyPlan ? '视频课件（请选择选修课件后提交学习计划）' : '视频课件' }}
                </p>
                <div class="video-item" v-for="(i, _i) in videos" :key="_i">
                  <div class="video-title">{{ _i + 1 }}.{{ i.title }}</div>
                  <div class="video-item-list" v-for="(s, _s) in i.coursewares" :key="_s"
                    :class="{ active: s.id == activeVideo && s.sectionId == actvieVideoSections }"
                    @click="viewViedo(s)">
                    <div class="video-item-list__top">
                    <van-checkbox
                      v-if="needStudyPlan && !planLocked"
                      :model-value="(s.required !== false && s.isRequired !== false) || localSelectedElectives.includes(s.id)"
                      :disabled="s.required !== false && s.isRequired !== false"
                      @update:model-value="(val) => toggleElective(s.id, val)"
                      shape="square"
                      icon-size="16px"
                      style="flex-shrink: 0; margin-right: 6px"
                    />
                    <div class="main-title">
                      <el-icon class="main-title-icon" style="margin-right: 5px"><VideoCameraFilled /></el-icon>
                      <van-tag
                        v-if="needStudyPlan"
                        :type="isCoursewareRequired(s) ? 'danger' : 'success'"
                        :plain="!isCoursewareRequired(s)"
                        size="medium"
                        class="main-title-tag"
                      >
                        <span style="display: inline-flex; align-items: center; gap: 2px">
                          <van-icon v-if="isCoursewareRequired(s)" name="lock" style="font-size: 14px" />
                          <span>{{ isCoursewareRequired(s) ? '必修' : '选修' }}</span>
                        </span>
                      </van-tag>
                      <span class="main-title-text" :title="s.title">{{ s.title }}</span>
                    </div>
                    <div class="video-item-list__meta">
                    <span class="timer">{{ formatterData(s.vedio && s.vedio.timeLength) }}</span>
                    <span v-if="s.classHour" class="class-hour-tag"><span class="class-hour-num">{{ s.classHour }}</span> 课时</span>
                    </div>
                    </div>
                    <p class="video-item-list__progress">
                      <span class="video-item-list__progress-label">学习进度：</span>{{ coursewareProgressText(s) }}<span :class="isCoursewareDone(s) ? 'status-done' : 'status-undone'">{{ isCoursewareDone(s) ? "已完成" : "未完成" }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div v-if="needStudyPlan && !planLocked" class="study-plan-footer">
                <div class="plan-stats">
                  <span>必修 {{ requiredClassHours }} 课时</span>
                  <span class="divider">|</span>
                  <span>已选选修 {{ selectedElectiveHours }} 课时</span>
                  <span class="divider">|</span>
                  <span v-if="remainingHours > 0" style="color: #e6a23c">还差 {{ remainingHours.toFixed(1) }} 课时</span>
                  <span v-else style="color: #67c23a">已满足</span>
                </div>
                <van-button type="primary" :disabled="!canSubmitPlan" size="small" @click="submitStudyPlan">提交我的学习计划</van-button>
              </div>
            </div>
            <div class="empty" v-if="!(needStudyPlan && planLocked) && !videos.length">暂无课程视频</div>
          </template>
          </div>
        </van-tab>
        <van-tab title="视频直播">
          <div
            v-if="lives.length"
            style="margin-bottom: 20px; background: #f9f9f9; padding: 10px"
          >
            <div
              class="ailve-item"
              v-for="(i, _i) in lives"
              :key="_i"
              @click="viewIives(i, _i)"
              :class="{ active: activelives == _i }"
            >
              {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
              <div class="description">{{ i.aliveDate }}</div>
            </div>
          </div>
          <!-- <div
            class="ailve-item"
            v-for="(i, _i) in lives"
            :key="_i"
            @click="viewIives(i, _i)"
            :class="{ active: i.living }"
          >
            {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
            <div class="description">{{ i.aliveDate }}</div> 
          </div>-->
          <div class="empty" v-if="!lives.length">暂无直播视频</div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { VideoCameraFilled } from "@element-plus/icons-vue";
import { Dialog, Toast } from "vant";
let VideocurrentTime = 0;
export default {
  name: "curriculum",
  components: { VideoCameraFilled },
  data() {
    return {
      videoId: "",
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isHorizontal: false,
      httpsLocation:
        // "https://tecsf.marsontec.com",
        "https://tecsf.gdcoh.com",
      activeTabsNames: "second",
      videoType: "",
      viewTitle: "",
      description: "",
      videos: [],
      activeVideo: 0,
      lives: [],
      activelives: "",
      livesVideo: null,
      fullScreen: false,
      fullScreenWidth: document.documentElement.clientHeight,
      fullScreenHeight: document.documentElement.clientWidth,
      playerPlaying: false,
      lastValidPlaybackTime: 0,
      seekingBlocked: false,
      seekRestoreTimer: null,
      lastSeekWarningAt: 0,
      tabLockId: "",
      lockStorageKey: "",
      lockHeartbeatTimer: null,
      lockHeartbeatMs: 10000,
      lockExpireMs: 60000,
      hasCourseLock: false,
      lockBlocked: false,
      lockListenerBound: false,
      // 课件完成判定相关：达到该比例后尝试触发一次“完成”上报，由后端统一校验
      coursewareCompleteThreshold: 0.8,
      hasTriedCompleteOnce: false,
      // 课件进度上报节流
      lastCoursewareProgressReportTime: 0,
      coursewareProgressThrottleMs: 10000,
      playerOptions: {
        //播放速度
        playbackRates: [],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频·。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          // {
          //   //类型
          //   type: "video/mp4",
          //   //url地址
          //   src: "https://media.w3.org/2010/05/sintel/trailer.mp4",
          // },
        ],
        //你的封面地址
        // poster:
        // "https://gimg2.baidu.com/image_search/src=http%3A%2F%2F1812.img.pp.sohu.com.cn%2Fimages%2Fblog%2F2009%2F11%2F18%2F18%2F8%2F125b6560a6ag214.jpg&refer=http%3A%2F%2F1812.img.pp.sohu.com.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1624024420&t=606e426a40c26ff068470eabe257afab",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: false,
        },
      },
      currentTime: 0,
      examDetail: null,
      activeTab: 1,
      courseDetail: null,
      // 进度模式与学习计划
      isNewProgressMode: false,
      serverProgress: 0,
      needStudyPlan: false,
      planLocked: false,
      totalClassHours: 0,
      requiredClassHours: 0,
      electiveTargetClassHours: 0,
      selectedElectives: [],
      localSelectedElectives: [],
      actvieVideoSections: 0,
    };
  },
  computed: {
    selectedElectiveHours() {
      if (!this.needStudyPlan) return 0;
      let total = 0;
      this.videos.forEach(section => {
        (section.coursewares || []).forEach(cw => {
          if ((cw.required === false || cw.isRequired === false) && this.localSelectedElectives.includes(cw.id)) {
            total += (cw.classHour || 0);
          }
        });
      });
      return Math.round(total * 10) / 10;
    },
    remainingHours() {
      return Math.max(0, this.electiveTargetClassHours - this.selectedElectiveHours);
    },
    canSubmitPlan() {
      return this.electiveTargetClassHours - this.selectedElectiveHours <= 0.0001;
    },
    planSections() {
      if (!this.needStudyPlan || !this.planLocked) return [];
      return this.videos.map(section => ({
        ...section,
        coursewares: (section.coursewares || []).filter(cw =>
          (cw.required !== false && cw.isRequired !== false) || this.selectedElectives.includes(cw.id)
        )
      })).filter(section => section.coursewares.length > 0);
    },
    extraSections() {
      if (!this.needStudyPlan || !this.planLocked) return [];
      return this.videos.map(section => ({
        ...section,
        coursewares: (section.coursewares || []).filter(cw =>
          (cw.required === false || cw.isRequired === false) && !this.selectedElectives.includes(cw.id)
        )
      })).filter(section => section.coursewares.length > 0);
    },
    videoPlayerRemountKey() {
      const src = this.playerOptions.sources && this.playerOptions.sources[0] && this.playerOptions.sources[0].src;
      return [this.videoType, String(this.activeVideo), String(this.activelives), src || ""].join("|");
    },
  },
  created() {
    this.videoId = this.$route.query && this.$route.query.id;
    this.cleanOtherUsersCache();
    this.initData();
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.seekRestoreTimer) {
      clearTimeout(this.seekRestoreTimer);
      this.seekRestoreTimer = null;
    }
    // 已取消单窗口限制，不再释放锁
  },
  methods: {
    isCoursewareDone(courseware) {
      return !!(courseware && (courseware.isDone === true || courseware.done === true));
    },
    isCoursewareRequired(s) {
      return !!(s && s.required !== false && s.isRequired !== false);
    },
    // 清理其他用户的缓存数据，节省localStorage空间
    cleanOtherUsersCache() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      if (!userInfo.userName) return;

      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只保留当前用户的缓存数据
      const currentUserCache = list.filter(
        (el) => el.userName === userInfo.userName
      );
      
      // 如果数据有变化才更新（避免不必要的写入）
      if (currentUserCache.length !== list.length) {
        this.$storage.setStorage([
          {
            key: "vidoDataList",
            value: currentUserCache,
          },
        ]);
      }
    },
    initializeCourseLock() {
      // 已取消单窗口限制，此方法不再执行任何操作
      // 保留方法定义以避免可能的调用错误
    },
    generateTabLockId() {
      return `${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
    },
    getCourseLockStorageKey() {
      const courseId = this.$route.query && this.$route.query.id;
      return courseId ? `course_tab_lock_${courseId}` : "";
    },
    parseLockPayload(value) {
      if (!value) return null;
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    },
    getCurrentLockPayload() {
      if (!this.lockStorageKey || typeof window === "undefined") return null;
      return this.parseLockPayload(localStorage.getItem(this.lockStorageKey));
    },
    isLockExpired(payload) {
      if (!payload || !payload.timestamp) return true;
      return Date.now() - payload.timestamp > this.lockExpireMs;
    },
    writeLockPayload(payload) {
      if (!this.lockStorageKey || typeof window === "undefined") return;
      localStorage.setItem(this.lockStorageKey, JSON.stringify(payload));
    },
    acquireCourseLock() {
      // 已取消单窗口限制，始终返回 true 表示获取成功
      return true;
    },
    startLockHeartbeat() {
      // 已取消单窗口限制，不再启动心跳机制
      // 清理可能存在的旧定时器
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    stopLockHeartbeat() {
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    releaseCourseLock(removeEntry = true) {
      // 已取消单窗口限制，仅清理可能存在的定时器
      this.stopLockHeartbeat();
    },
    handleLockStorageEvent(event) {
      // 已取消单窗口限制，不再处理锁相关事件
    },
    handleLockDenied() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    handleLockLost() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    notifyLockConflict(message) {
      const redirect = () => {
        this.$router.replace({
          path: "/courseDetail",
          query: {
            id: this.$route.query.id,
            courseId: this.$route.query.courseId,
          },
        });
      };
      if (this.$dialog?.alert) {
        this.$dialog
          .alert({
            title: "提示",
            message,
          })
          .finally(redirect);
      } else if (this.$toast) {
        this.$toast(message);
        redirect();
      } else {
        redirect();
      }
    },
    ensureCourseLockActive() {
      // 已取消单窗口限制，始终返回 true 允许操作
      return true;
    },
    handleBeforeUnload() {
      // 已取消单窗口限制，不再释放锁
    },
    getActiveCourseware() {
      const section = this.videos.find(
        (el) => el.id == this.actvieVideoSections
      );
      if (!section) {
        return null;
      }
      return section.coursewares.find((item) => item.id == this.activeVideo) || null;
    },
    getActiveCoursewareDuration() {
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio) {
        return 0;
      }
      return Number(courseware.vedio.timeLength) || 0;
    },
    clampPlaybackTime(rawTime, { updateTracker = true } = {}) {
      const duration = this.getActiveCoursewareDuration();
      const numeric = Math.max(Number(rawTime) || 0, 0);
      const safeTime = duration ? Math.min(numeric, duration) : numeric;
      if (updateTracker && safeTime > this.lastValidPlaybackTime) {
        this.lastValidPlaybackTime = safeTime;
      }
      return safeTime;
    },
    timeupdate(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType != "liveing") {
        const rawTime = player.cache_.currentTime;
        const safeTime = this.clampPlaybackTime(rawTime);
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: safeTime || null,
          },
          () => {},
          true
        );
        if (!this.currentPlayTimer || !this.currentPlayStatus) {
          this.videos.forEach((el) => {
            if (el.id == this.actvieVideoSections) {
              el.coursewares.forEach((item) => {
                if (item.id == this.activeVideo && !this.isCoursewareDone(item)) {
                  this.currentPlayTimer = item.vedio.timeLength;
                  item.currentTime = safeTime;
                }
              });
            }
          });
          this.currentPlayStatus = this.currentPlayTimer
            ? safeTime / this.currentPlayTimer >= 1.0
            : false;
          if (this.currentPlayStatus) {
            this.onPlayerEnded();
          }
          VideocurrentTime = safeTime;
        }

        // 周期性向后端上报课件播放进度（单位：秒），用于统一的完成判定
        const now = Date.now();
        if (
          this.videoId &&
          this.activeVideo &&
          (!this.lastCoursewareProgressReportTime ||
            now - this.lastCoursewareProgressReportTime >=
              this.coursewareProgressThrottleMs)
        ) {
          this.lastCoursewareProgressReportTime = now;
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${this.videoId}/${this.activeVideo}`,
              { currentTime: safeTime }
            )
            .catch(() => {});
        }

        // 当本课件已观看比例首次达到阈值时，尝试触发一次“完成”上报
        const duration = this.getActiveCoursewareDuration();
        if (
          duration &&
          !this.hasTriedCompleteOnce &&
          safeTime / duration >= this.coursewareCompleteThreshold
        ) {
          this.hasTriedCompleteOnce = true;
          // 先同步当前进度到后端，确保后端有最新的观看时间
          // 这避免了完成上报时后端进度滞后导致的验证失败
          const courseId = this.$route.query && this.$route.query.id;
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${courseId}/${this.activeVideo}`,
              { currentTime: safeTime }
            )
            .finally(() => {
              let learningProgress;
              if (this.isNewProgressMode) {
                learningProgress = this.serverProgress || 0;
              } else {
                let completedCourses = 0;
                let totalCourses = 0;
                this.videos.forEach((section) => {
                  if (section.coursewares) {
                    section.coursewares.forEach((courseware) => {
                      totalCourses++;
                      if (
                        this.isCoursewareDone(courseware) ||
                        courseware.id === this.activeVideo
                      ) {
                        completedCourses++;
                      }
                    });
                  }
                });
                learningProgress = totalCourses > 0
                  ? ((completedCourses / totalCourses) * 100).toFixed(2)
                  : 0;
              }
              this.reportCoursewareCompletion(learningProgress, 0, safeTime);
            });
        }

      }
    },
    onClickLeft() {
      // 从播放页返回课程详情时标记需要刷新，确保总学习进度等数据是最新的（含 keep-alive 场景）
      try {
        localStorage.setItem("needRefreshCourseDetail", "true");
      } catch (e) {}
      this.$router.replace({
        path: "/courseDetail",
        query: {
          id: this.$route.query.id,
          courseId: this.$route.query.courseId,
        },
      });
    },
    formatterData(time) {
      const sec = Number(time);
      if (!Number.isFinite(sec) || sec <= 0) {
        return "-";
      }
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = Math.floor(sec % 60);
      const parts = [];
      if (h > 0) parts.push(h + "时");
      if (m > 0) parts.push(m + "分");
      if (s > 0 || parts.length === 0) parts.push(s + "秒");
      return parts.join("");
    },
    buildPlayableSrc(url) {
      if (!url || typeof url !== "string") return "";
      const u = url.trim();
      if (!u) return "";
      if (/^https?:\/\//i.test(u)) return u;
      return (this.httpsLocation || "").replace(/\/$/, "") + (u.startsWith("/") ? u : "/" + u);
    },
    initData() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只获取当前用户的缓存数据
      const videoHistoryMap = {};
      list
        .filter((el) => el.userName === userInfo.userName)
        .map((el) => (videoHistoryMap[el.activeVideoID] = el.time));
      const id = this.$route.query && this.$route.query.id;
      this.$https.get("/api/my/course/details/" + id).then((res) => {
        if (res.success) {
          const data = res.data;
          this.description = data.description;
          this.viewTitle = data.title || this.viewTitle;
          this.playerOptions.sources = [];
          this.activeVideo = null;
          this.actvieVideoSections = 0;
          this.activelives = "";
          this.videoType = "";
          // 学习计划字段
          this.totalClassHours = data.totalClassHours || 0;
          this.requiredClassHours = data.requiredClassHours || 0;
          this.electiveTargetClassHours = data.electiveTargetClassHours || 0;
          this.planLocked = data.planLocked || false;
          this.selectedElectives = data.selectedElectives || [];
          this.localSelectedElectives = [...(data.selectedElectives || [])];
          this.isNewProgressMode = this.totalClassHours > 0;
          this.serverProgress = data.progress || 0;
          const hasElectives = data.coursewares?.some(cw => cw.required === false || cw.isRequired === false);
          this.needStudyPlan = this.totalClassHours > 0 && !!hasElectives;
          // 直播
          let _lives = data.lives.map((el) => {
            return {
              ...el,
              ...this.judeLives(res, el),
            };
          });
          this.lives = _lives
            .filter((el) => el.living)
            .concat(_lives.filter((el) => !el.living));
          // 进入页面不自动播放直播，由用户点击后再打开
          // 视频（进入页面不自动加载课件视频，避免自动播放）
          this.videos = data.courseSections.map((el) => {
            return {
              ...el,
              coursewares: data.coursewares
                .filter((item) => item.sectionId == el.id)
                .map((val) => {
                  val.currentTime = videoHistoryMap[val.id];
                  return val;
                }),
            };
          });
          // 兼容历史遗留数据：检查并修复已学完但未标记完成的课件
          this.fixHistoricalCoursewareProgress(data.coursewares, id);
        }
      });
    },
    // 上报课件完成状态（带重试机制）
    reportCoursewareCompletion(learningProgress, retryCount = 0, currentTime = null) {
      const courseId = this.$route.query && this.$route.query.id;
      if (!courseId || !this.activeVideo) {
        return Promise.resolve();
      }
      // 如果有 currentTime，一并传递给后端（解决进度同步失败的问题）
      let url = `/api/my/course/coursewareDone/${courseId}/${this.activeVideo}?progress=${learningProgress}&completed=true`;
      if (currentTime != null && currentTime > 0) {
        url += `&currentTime=${currentTime}`;
      }
      
      return this.$https.put(url)
        .then(() => {
          // 上报成功，重置重试计数
          this.completionRetryCount = 0;
          this.pendingCompletionReport = null;
          // 以服务器为准：重新拉取课程详情，用服务端返回的 isDone 更新列表，只有成功落库才算“已完成”
          const id = this.$route.query && this.$route.query.id;
          if (id) {
            this.$https.get("/api/my/course/details/" + id).then((res) => {
              if (res.success && res.data && res.data.coursewares) {
                const map = {};
                res.data.coursewares.forEach((cw) => {
                  map[cw.id] = this.isCoursewareDone(cw);
                });
                this.videos.forEach((section) => {
                  (section.coursewares || []).forEach((cw) => {
                    if (Object.prototype.hasOwnProperty.call(map, cw.id)) {
                      cw.isDone = map[cw.id];
                      cw.done = map[cw.id];
                    }
                  });
                });
                this.$forceUpdate?.();
                this.checkAllVideosComplete();
              }
            });
          }
        })
        .catch((error) => {
          // 如果是完成状态上报失败，且未超过最大重试次数，则重试
          if (retryCount < this.maxCompletionRetries) {
            const delay = this.completionRetryDelayMs * Math.pow(2, retryCount); // 指数退避
            this.pendingCompletionReport = {
              learningProgress: learningProgress,
              retryCount: retryCount + 1,
              currentTime: currentTime,
              delay: delay
            };
            console.warn(`[课件完成上报] 失败，${delay}ms 后重试 (${retryCount + 1}/${this.maxCompletionRetries}):`, error);
            setTimeout(() => {
              if (this.pendingCompletionReport) {
                this.reportCoursewareCompletion(
                  this.pendingCompletionReport.learningProgress,
                  this.pendingCompletionReport.retryCount,
                  this.pendingCompletionReport.currentTime
                );
              }
            }, delay);
          } else {
            // 超过最大重试次数，记录到本地，等待页面加载时修复
            console.error(`[课件完成上报] 超过最大重试次数，将在页面加载时自动修复`);
            this.pendingCompletionReport = {
              learningProgress: learningProgress,
              retryCount: retryCount,
              currentTime: currentTime,
              delay: 0
            };
          }
        });
    },
    // 修复历史遗留数据：自动补传已完成但后台未标记的课件
    // 同时处理网络失败导致的上报失败情况
    fixHistoricalCoursewareProgress(coursewares, courseId) {
      if (!coursewares || !Array.isArray(coursewares) || !courseId) {
        return;
      }
      coursewares.forEach((courseware) => {
        // 检查条件：课件有视频时长，且播放进度达到完成阈值（80%），但后台未标记为完成
        if (
          courseware.vedio &&
          courseware.vedio.timeLength &&
          courseware.currentTime != null &&
          courseware.currentTime / courseware.vedio.timeLength >= this.coursewareCompleteThreshold &&
          !this.isCoursewareDone(courseware)
        ) {
          // 计算总学习进度：已完成的课程 + 当前课件（假设已完成）/全部课程*100
          let completedCourses = 0;
          let totalCourses = 0;
          coursewares.forEach((cw) => {
            totalCourses++;
            if (this.isCoursewareDone(cw) || (cw.id === courseware.id)) {
              completedCourses++;
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 为当前课件单独调用接口，补传completed=true
          // 传递 currentTime 确保后端能获取最新进度
          this.$https
            .put(
              "/api/my/course/coursewareDone/" +
                courseId +
                "/" +
                courseware.id +
                "?progress=" +
                learningProgress +
                "&completed=true" +
                "&currentTime=" +
                (courseware.currentTime || courseware.vedio?.timeLength || 0)
            )
            .then(() => {
              console.log(`[自动修复] 课件 ${courseware.id} 完成状态已修复`);
              // 补传成功后立即更新当前页对应课件的 isDone，避免“重新进来仍显示未完成”
              courseware.isDone = true;
              courseware.done = true;
              this.$forceUpdate?.();
            })
            .catch((error) => {
              console.warn(`[自动修复] 课件 ${courseware.id} 完成状态修复失败，将在下次页面加载时重试:`, error);
            });
        }
      });
    },
    onPlayerPlaying() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (!this.playerPlaying) {
        this.playerPlaying = true;
        this.initFullScreem();
        this.onPlayerPlay();
        console.log("开始播放了");
        // this.$refs.videoPlayer.player.currentTime(this.currentTime);
      }
    },
    // 播放回调
    onPlayerPlay() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        this.$refs.videoPlayer.player.currentTime(this.currentTime);
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
          },
          (list, listIndex) => {
            const resumeTime = list[listIndex].time || 0;
            const safeTime = this.clampPlaybackTime(resumeTime);
            this.$refs.videoPlayer.player.currentTime(safeTime);
          }
        );
      }
    },
    // 暂停回调
    onPlayerPause(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      console.log(this.$refs.videoPlayer);
      const safeTime = this.clampPlaybackTime(player.cache_.currentTime);
      this.currentTime = safeTime;
      this.setVidoData(
        {
          detailsID: this.videoId,
          activeVideoID: this.activeVideo,
          time: safeTime,
        },
        () => {},
        true
      );
    },
    onPlayerSeeking() {
      // 已取消单窗口限制，但保留快进检测机制
      if (this.videoType === "liveing") {
        return;
      }
      const playerInstance = this.$refs.videoPlayer?.player;
      if (!playerInstance) return;
      const requestedTime = playerInstance.currentTime();
      const tolerance = 0.5;
      if (requestedTime > this.lastValidPlaybackTime + tolerance) {
        this.seekingBlocked = true;
        const restoreTime = this.lastValidPlaybackTime;
        if (this.seekRestoreTimer) {
          clearTimeout(this.seekRestoreTimer);
        }
        this.seekRestoreTimer = setTimeout(() => {
          playerInstance.currentTime(restoreTime);
          this.seekRestoreTimer = null;
        }, 0);
        const now = Date.now();
        if (now - this.lastSeekWarningAt > 3000 && this.$toast) {
          this.$toast("当前课程不支持快进");
          this.lastSeekWarningAt = now;
        }
      }
    },
    onPlayerSeeked() {
      if (this.seekingBlocked) {
        this.seekingBlocked = false;
      }
    },
    onPlayerEnded() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        let target = this.lives[this.activelives];
        let url =
          target.vedios.length > target.livingIndex + 1
            ? target.vedios[target.livingIndex + 1].url
            : "";
        target.livingIndex += 1;
        if (!url) this.playerOptions.notSupportedMessage = "已经结束！";
        const playUrl = url ? this.buildPlayableSrc(url) : "";
        const isHls = playUrl.indexOf(".m3u8") > 0;
        this.playerOptions.sources = [
          {
            type: isHls ? "application/x-mpegURL" : "video/mp4",
            src: playUrl,
          },
        ];
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: 0,
          },
          () => {},
          true
        );
        this.lastValidPlaybackTime = 0;
        let data = this.videos
          .find((el) => el.id == this.actvieVideoSections)
          .coursewares.find((el) => el.id == this.activeVideo);

        if (this.isCoursewareDone(data)) return;
        let learningProgress;
        if (this.isNewProgressMode) {
          learningProgress = this.serverProgress || 0;
        } else {
          let completedCourses = 0;
          let totalCourses = 0;
          this.videos.forEach((section) => {
            if (section.coursewares) {
              section.coursewares.forEach((courseware) => {
                totalCourses++;
                if (this.isCoursewareDone(courseware)) {
                  completedCourses++;
                }
              });
            }
          });
          if (!this.isCoursewareDone(data)) {
            completedCourses++;
          }
          learningProgress = totalCourses > 0
            ? ((completedCourses / totalCourses) * 100).toFixed(2)
            : 0;
        }

        // 视频播放完成，传递完整的视频时长作为 currentTime
        const videoDuration = data.vedio?.timeLength || 0;
        this.$https
          .put(
            "/api/my/course/coursewareDone/" +
              this.$route.query.id +
              "/" +
              data.id +
              "?progress=" +
              learningProgress +
              "&completed=true" +
              "&currentTime=" +
              videoDuration
          )
          .then(() => {
            this.videos.forEach((el) => {
              if (el.id == this.actvieVideoSections) {
                el.coursewares.forEach((item) => {
                  if (item.id == this.activeVideo) {
                    item.isDone = true;
                    item.done = true;
                  }
                });
              }
            });

            // 检查是否所有视频都已完成
            this.checkAllVideosComplete();
          });
      }
    },
    //获取课程详情 判断是否有考试
    async getExamDetail() {
      const courseId = this.$route.query && this.$route.query.courseId;
      const res = await this.$https.get(`/api/my/registration/${courseId}`);
      if (res.success) {
        this.courseDetail = res.data;
        this.examDetail = res.data?.exam[0] || null;
      }
    },
    // 检查是否所有视频都已完成
    async checkAllVideosComplete() {
      let allVideosComplete = true;

      // 遍历所有章节和课件
      for (let section of this.videos) {
        if (section.coursewares) {
          for (let courseware of section.coursewares) {
            if (!this.isCoursewareDone(courseware)) {
              allVideosComplete = false;
              break;
            }
          }
        }
        if (!allVideosComplete) break;
      }
      if (allVideosComplete) {
        await this.getExamDetail();
      }
      //考试需要监考 不展示弹窗
      if (this.examDetail?.originExam?.needCam) {
        return;
      }

      // 显示考试提示弹窗
      if (allVideosComplete && this.examDetail?.examId) {
        // 判断考试时间是否已开始
        const currentTime = new Date().getTime();
        const examStartTime = this.examDetail.originExam?.startDate;
        const examEndTime = this.examDetail.originExam?.endDate;

        if (examStartTime && examEndTime) {
          if (currentTime >= examStartTime && currentTime <= examEndTime) {
            // 考试时间已开始，显示弹窗
            this.showExamDialog();
          }
        }
      }
    },
    // 显示考试提示弹窗
    showExamDialog() {
      this.$dialog
        .confirm({
          title: "学习完成",
          message: "恭喜您已完成课程学习！是否立即考试？",
          confirmButtonText: "立即考试",
          cancelButtonText: "稍后考试",
          confirmButtonColor: "#1989fa",
        })
        .then(() => {
          this.goToExam();
        });
    },
    // 跳转到考试页面
    goToExam() {
      this.$router.push({
        path: "/mobileExamination",
        query: {
          title: this.examDetail?.examTitle || "",
          examinationId: this.examDetail?.examId,
        },
      });
    },
    // 直播
    viewIives(item, i) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      this.playerPlaying = false;
      this.videoType = "liveing";
      if (!item.living) {
        this.$message({
          message: "尚未开始或已经结束",
          type: "warning",
        });
        return;
      }
      this.viewTitle = item.title;
      this.activelives = i;
      const liveUrl = item.vedios[item.livingIndex].url;
      const playUrl = this.buildPlayableSrc(liveUrl);
      const isHls = playUrl.indexOf(".m3u8") > 0;
      this.playerOptions.sources = [
        {
          type: isHls ? "application/x-mpegURL" : "video/mp4",
          src: playUrl,
        },
      ];
      this.currentTime =
        item.currentTime + (moment().valueOf() - item.ajaxTime) / 1000;

      this.$https
        .put(
          "/api/my/course/liveRecord/" + this.$route.query.id + "/" + item.id
        )
        .then((res) => {
          console.log("liveRecord-mobile");
          console.log(res);
        })
        .catch((err) => {
          console.log("liveRecord-mobile-error");
          console.log(err);
        });
    },
    coursewareProgressText(s) {
      const len = s.vedio && s.vedio.timeLength ? Number(s.vedio.timeLength) : 0;
      if (s.currentTime != null && len > 0) {
        const pct = (s.currentTime / len > 1 ? 1 : s.currentTime / len) * 100;
        return "（" + pct.toFixed(2) + "%）";
      }
      return this.isCoursewareDone(s) ? "（100%）" : "";
    },
    toggleElective(coursewareId, checked) {
      if (checked) {
        if (!this.localSelectedElectives.includes(coursewareId)) {
          this.localSelectedElectives.push(coursewareId);
        }
      } else {
        this.localSelectedElectives = this.localSelectedElectives.filter(id => id !== coursewareId);
      }
    },
    async submitStudyPlan() {
      const courseId = this.$route.query && this.$route.query.id;
      try {
        await this.$https.put(`/api/my/course/studyPlan/${courseId}`, {
          selectedCoursewareIds: this.localSelectedElectives
        });
        this.$toast.success('学习计划提交成功！');
        this.initData();
      } catch (e) {
        this.$toast.fail(e?.response?.data?.debug || '提交失败，请重试');
      }
    },
    modifyPlan() {
      Dialog.confirm({
        title: '修改学习计划',
        message:
          '修改计划可能导致您的总学习进度发生变化（如取消已完成的选修课将扣除进度），确认继续吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.planLocked = false;
          this.localSelectedElectives = [...this.selectedElectives];
        })
        .catch(() => {});
    },
    // 视频
    viewViedo(item) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (!item || !item.vedio || !item.vedio.url) {
        this.$toast("该课件暂无可播放视频，请稍后再试或联系管理员");
        return;
      }
      if (this.needStudyPlan && !this.planLocked) {
        this.$toast('请先挑选选修课并提交学习计划后再开始学习！');
        return;
      }
      if (this.needStudyPlan && this.planLocked) {
        const isInPlan = (item.required !== false && item.isRequired !== false) || this.selectedElectives.includes(item.id);
        if (!isInPlan) {
          this.$toast('您正在观看未选修的拓展课件，该部分学习不计入总学时进度哦~');
        }
      }
      if (this.isCoursewareDone(item)) {
        const courseId = this.$route.query && this.$route.query.id;
        if (courseId && item.id) {
          // 计算总学习进度
          let completedCourses = 0;
          let totalCourses = 0;
          this.videos.forEach((section) => {
            if (section.coursewares) {
              section.coursewares.forEach((courseware) => {
                totalCourses++;
                if (this.isCoursewareDone(courseware)) {
                  completedCourses++;
                }
              });
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 调用done接口，传递 currentTime 确保后端能获取最新进度
          const itemCurrentTime = item.currentTime || item.vedio?.timeLength || 0;
          this.$https
            .put(
              `/api/my/course/coursewareDone/${courseId}/${item.id}?progress=${learningProgress}&completed=true&currentTime=${itemCurrentTime}`
            )
            .catch(() => {
              // 静默失败，不影响用户体验
            });
        }
      }
      this.playerPlaying = false;
      this.currentTime = 0;
      this.currentPlayTimer = 0;
      this.currentPlayStatus = false;
      this.hasTriedCompleteOnce = false;
      this.videoType = "video";
      this.activelives = null;
      this.viewTitle = item.title;
      this.actvieVideoSections = item.sectionId;
      this.activeVideo = item.id;
      const resumeTime = item.currentTime || 0;
      const safeTime = this.clampPlaybackTime(resumeTime);
      this.lastValidPlaybackTime = safeTime;
      item.currentTime = safeTime;
      this.seekingBlocked = false;
      if (this.seekRestoreTimer) {
        clearTimeout(this.seekRestoreTimer);
        this.seekRestoreTimer = null;
      }
      const playUrl = this.buildPlayableSrc(item.vedio.url);
      if (!playUrl) {
        this.$toast("该课件暂无可播放视频，请稍后再试或联系管理员");
        return;
      }
      const isHls = playUrl.indexOf(".m3u8") > 0;
      this.playerOptions.sources = [
        {
          type: isHls ? "application/x-mpegURL" : "video/mp4",
          src: playUrl,
        },
      ];
    },
    // 判断是否有直播数据
    judeLives(res, item) {
      let isAlive = false;
      let startTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.startTime + ":00"
      ).valueOf();
      let endTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.endTime + ":00"
      ).valueOf();
      if (startTime >= endTime) {
        endTime = moment(
          moment().format("YYYY-MM-DD") + " " + item.endTime + ":00"
        )
          .add(1, "d")
          .valueOf();
      }
      let aliveDate;
      // 判断日期
      Object.keys(item.dateSettings).forEach((el) => {
        let target = item.dateSettings[el];
        if (target) {
          switch (el) {
            case "monthDays":
              if (target.includes(moment(parseInt(res.stime)).format("DD"))) {
                isAlive = true;
              }
              aliveDate =
                "每月" +
                target.map((el) => el + 1).join(",") +
                "号 " +
                item.startTime +
                " 开始";
              break;
            case "specDays":
              target = target.map((el) =>
                moment(parseInt(el)).format("YYYY-MM-DD")
              );
              if (
                target.includes(
                  moment(parseInt(res.stime)).format("YYYY-MM-DD")
                )
              ) {
                isAlive = true;
              }
              aliveDate = target.join(",") + " " + item.startTime + " 开始";
              break;
            case "weeklyDays":
              if (target.includes(moment(parseInt(res.stime)).day())) {
                isAlive = true;
              }
              aliveDate =
                "每周" +
                target.map((el) => getWeekDate(el)).join(",") +
                " " +
                item.startTime +
                " 开始";
              break;
          }
        }
      });
      // 判断时间
      if (isAlive) {
        if (!(res.stime >= startTime && res.stime <= endTime)) {
          isAlive = false;
        }
      }
      // 计算直播播放时间,直播开始时间减去当前服务器时间得到已经开始的时间
      let currentTime = (res.stime - startTime) / 1000;
      let _currentTime = 0;
      let timeLength = 0;
      let livingIndex = 0;
      if (isAlive) {
        for (let i = 0; i <= item.vedios.length; i++) {
          if (timeLength >= currentTime) {
            livingIndex = i;
            _currentTime =
              item.vedios[i - 1].timeLength - (timeLength - currentTime);
            break;
          }
          timeLength += item.vedios[i].timeLength;
        }
      }
      return {
        currentTime: _currentTime,
        living: isAlive,
        // living: true,
        livingIndex: livingIndex ? livingIndex - 1 : 0,
        aliveDate: aliveDate,
        stime: res.stime,
        ajaxTime: moment().valueOf(),
      };
    },
    setVidoData(options, callBack, isSet = false) {
      if (!this.ensureCourseLockActive()) {
        return false;
      }
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      // 如果是直接不保存数据
      if (this.videoType == "liveing") {
        return false;
      }
      // 保存当前数据到本地（用于保存回显视频地址和位置）
      let list = this.$storage.getStorage("vidoDataList") || [];
      // 只查找当前用户的缓存记录
      let listIndex = list.findIndex(
        (p) =>
          Number(p.detailsID) === Number(options.detailsID) &&
          Number(p.activeVideoID) === Number(options.activeVideoID) &&
          userInfo.userName == p.userName
      );
      if (listIndex !== -1) {
        if (callBack) {
          callBack([...list], listIndex);
        }
        if (isSet) {
          list[listIndex] = {
            detailsID: Number(options.detailsID),
            activeVideoID: Number(options.activeVideoID),
            time: options.time != null ? options.time : list[listIndex].time,
            timeLength: options.timeLength || 0,
            userName: userInfo.userName,
          };
        }
      } else {
        list.push({
          detailsID: Number(options.detailsID),
          activeVideoID: Number(options.activeVideoID),
          time: options.time || 0,
          timeLength: options.timeLength || 0,
          userName: userInfo.userName,
        });
      }
      this.$storage.setStorage([
        {
          key: "vidoDataList",
          value: list,
        },
      ]);
    },
    initFullScreem() {
      this.$nextTick(() => {
        setTimeout(() => {
          const contain = document.getElementsByClassName("vjs-control-bar")[0];
          let newDom = document.createElement("div");
          newDom.setAttribute("class", "vjs-control");
          newDom.setAttribute("style", "position: absolute;right: 0;");
          newDom.innerHTML =
            '<span class="ep-icon-fullscreen" style="margin-top:8px;font-size: 16px;display:inline-flex;align-items:center;"><svg viewBox="0 0 1024 1024" width="1em" height="1em"><path d="M384 128v128H192v192H64V128h320zm192 0h320v320H768V256H576V128zm-192 576v192H64V576h128v128h192zm576-192v320H640V832h192V640h128z" fill="currentColor"/></svg></span>';
          contain.append(newDom);
          newDom.addEventListener("click", () => {
            this.fullScreen = !this.fullScreen;
          });
        }, 1000);
      });
    },
  },

  mounted() {
    const that = this;
    // 移动端的浏览器一般都支持window.orientation这个参数，通过这个参数可以判断出手机是处在横屏还是竖屏状态。
    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      function () {
        if (window.orientation === 180 || window.orientation === 0) {
          that.isHorizontal = false;
        }
        if (window.orientation === 90 || window.orientation === -90) {
          that.isHorizontal = true;
        }
      },
      false
    );
  },
};

function getWeekDate(date) {
  const list = [
    { name: "星期日", value: 0 },
    { name: "星期一", value: 1 },
    { name: "星期二", value: 2 },
    { name: "星期三", value: 3 },
    { name: "星期四", value: 4 },
    { name: "星期五", value: 5 },
    { name: "星期六", value: 6 },
  ];
  return list.find((el) => el.value == date).name;
}
</script>
<style lang="less">
  .mobileCurriculum {
  position: absolute;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  .video {
    position: relative;
    flex-shrink: 0;
  }
  .video-list {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    font-size: 18px;
    .van-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .van-tab {
        color: #646566;
        font-size: 15px;
      }
      .van-tab--active {
        color: #0a73c5;
        font-weight: 600;
      }
      .van-tabs__line {
        background: #0a73c5;
        height: 3px;
        border-radius: 2px;
      }
    }
    .van-tabs__content {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
    .van-tabs__track {
      height: 100%;
    }
    .van-tab__panel {
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0;
    }
    .mobile-tab-intro {
      height: 100%;
      overflow-y: auto;
      padding: 10px 20px;
      box-sizing: border-box;
      word-break: break-word;
    }
    .mobile-tab-course {
      height: 100%;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
      padding: 0 20px 10px;
      box-sizing: border-box;
    }
    .mobile-course-locked-scroll {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      background: #f5f7fa;
      padding: 8px 12px 12px;
      box-sizing: border-box;
    }
    .mobile-plan-block {
      padding: 4px 0 8px;
    }
    .mobile-plan-block--extra {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid #e8eaed;
    }
    .mobile-catalog-flat-root {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #f5f7fa;
    }
    .mobile-catalog-flat-scroll {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 12px;
      box-sizing: border-box;
      background: #f5f7fa;
    }
    .mobile-catalog-section-title {
      margin: 0 0 12px;
      padding: 0;
      color: #677897;
      font-size: 15px;
      font-weight: 600;
      line-height: 1.4;
    }
    .video-item {
      cursor: pointer;
      line-height: 1.45;
      white-space: normal;
      overflow: visible;
      border-bottom: 1px solid #e8eaed;
      padding-bottom: 12px;
      margin-bottom: 12px;
      font-weight: normal;
      color: #333333;
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
      .video-title {
        font-size: 14px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 10px;
        padding-left: 8px;
        border-left: 3px solid rgba(10, 115, 197, 0.35);
        line-height: 1.45;
        white-space: normal;
        overflow: visible;
      }
      .video-item-list {
        margin-left: 0;
        margin-bottom: 10px;
        padding: 10px 12px;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        box-sizing: border-box;
        white-space: normal;
        overflow: visible;
        transition: background 0.15s ease, box-shadow 0.15s ease;
        &:last-child {
          margin-bottom: 0;
        }
        &.active {
          background: rgba(10, 115, 197, 0.06);
          border-color: rgba(10, 115, 197, 0.35);
          box-shadow: inset 3px 0 0 #0a73c5;
          .video-item-list__progress {
            color: #606266;
          }
          .video-item-list__progress-label {
            color: #909399;
          }
        }
      }
      .video-item-list__progress {
        margin: 0;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #f0f0f0;
        font-size: 12px;
        line-height: 1.5;
        color: #606266;
      }
      .video-item-list__progress-label {
        color: #909399;
      }
      .video-item-list__top {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
        box-sizing: border-box;
      }
      .video-item-list__meta {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
      }
      .main-title {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: flex-start;
        gap: 6px;
        white-space: normal;
        .main-title-icon,
        .main-title-tag {
          flex-shrink: 0;
          margin-top: 2px;
        }
        .main-title-text {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          word-break: break-word;
          line-height: 1.45;
          font-size: 14px;
        }
      }
      .timer {
        text-align: right;
        white-space: nowrap;
        color: #969799;
        font-size: 13px;
      }
      .status-done {
        display: inline-block;
        margin-left: 4px;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 600;
        color: #fff;
        background: #52c41a;
        border-radius: 4px;
      }
      .status-undone {
        margin-left: 4px;
        color: #666;
        font-size: 12px;
      }
    }
    .ailve-item {
      cursor: pointer;
      line-height: 40px;
      border-bottom: 1px solid #e4e7ed;
      color: #b0b9ca;
      font-weight: bold;
      font-size: 18px;
      .description {
        font-size: 16px;
        font-weight: normal;
      }
    }
    .active {
      color: #0a73c5;
      .description {
        color: #677897;
      }
    }
    .class-hour-tag {
      display: inline-block;
      font-size: 12px;
      color: #606266;
      margin-left: 0;
      background: #f0f7fc;
      padding: 3px 8px;
      border-radius: 4px;
      line-height: 1.35;
      vertical-align: middle;
      border: 1px solid rgba(10, 115, 197, 0.22);
      border-left: 3px solid rgba(10, 115, 197, 0.55);
      font-weight: 500;
    }
    .class-hour-num {
      font-weight: 700;
      color: #303133;
    }
    .study-plan-footer {
      position: static;
      flex-shrink: 0;
      background: #fff;
      border-top: 1px solid #ebedf0;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .plan-stats {
        font-size: 12px;
        color: #606266;
        .divider {
          margin: 0 4px;
          color: #dcdfe6;
        }
      }
    }
  }
  .mobile-video-frame {
    display: inline-block;
    vertical-align: top;
    max-width: 100%;
  }
  .mobile-video-aspect {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
  }
  .mobile-video-player {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .mobile-video-player.video-player .video-js,
  .mobile-video-player .video-js {
    width: 100% !important;
    height: 100% !important;
    padding-top: 0 !important;
  }
  .mobile-video-placeholder {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 16px;
    box-sizing: border-box;
    overflow: hidden;
    background: radial-gradient(
      ellipse 95% 75% at 50% 38%,
      rgba(10, 115, 197, 0.15) 0%,
      rgba(6, 22, 44, 0.48) 44%,
      #050506 100%
    );
    border: 1px solid rgba(255, 255, 255, 0.06);
    &__glow {
      position: absolute;
      width: 130px;
      height: 130px;
      border-radius: 50%;
      background: rgba(10, 115, 197, 0.2);
      filter: blur(34px);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -55%);
      pointer-events: none;
    }
    &__icon-wrap {
      position: relative;
      width: 62px;
      height: 62px;
      border-radius: 50%;
      border: 1px solid rgba(255, 255, 255, 0.13);
      background: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 18px;
      box-shadow: 0 10px 32px rgba(0, 0, 0, 0.45);
    }
    &__icon {
      font-size: 34px;
      color: rgba(186, 218, 255, 0.92);
    }
    &__title {
      position: relative;
      margin: 0 0 8px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.02em;
      color: rgba(255, 255, 255, 0.92);
    }
    &__hint {
      position: relative;
      margin: 0;
      max-width: 260px;
      font-size: 13px;
      line-height: 1.55;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  @media all and (orientation: portrait) {
    .full-screen {
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* IE 9 */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg); /* Opera */
      position: fixed;
      z-index: 10000;
      background-color: #000;
    }
  }

  @media all and (orientation: landscape) {
    .full-screen {
      position: fixed;
      z-index: 10000;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      background-color: #000;
    }
  }
  .warning {
    width: 100%;
    background: #d4d8df;
    text-align: center;
    color: #da2828;
    height: 100%;
    padding: 10px;
  }
}

.van-tab {
  font-size: 18px;
}

.vjs-progress-control {
  display: none !important;
}
.vjs-fullscreen-control {
  position: absolute;
  right: 0;
}
.aliving {
  .vjs-play-control {
    display: none !important;
  }
  .vjs-current-time {
    display: none !important;
  }
  .vjs-tech {
    pointer-events: none;
  }
  .timeout-lives {
    text-align: center;
  }
}
</style>
